'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('../_babelHelpers-48e7a7f7.js');
require('../browser-05a2bba8.js');
require('../_commonjsHelpers-3fc1f64e.js');
require('../_react_commonjs-external-30e5c7b3.js');
var index = require('../index-db6682ea.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  margin: ", ";\n  font-size: ", ";\n  text-align: ", ";\n"], ["\n  margin: ", ";\n  font-size: ", ";\n  text-align: ", ";\n"]);

var DivText = styled__default.div(_templateObject, function (props) {
  return props.margin ? props.margin : "5px 0";
}, function (props) {
  return props.size ? props.size : "16px";
}, function (props) {
  return props.textAlign ? props.textAlign : "justify";
});

var TermText = function TermText(_ref) {
  var terms = _ref.terms,
      rest = _babelHelpers.objectWithoutProperties(_ref, ["terms"]);
  return React__default.createElement(
    React__default.Fragment,
    null,
    terms.map(function (term) {
      return React__default.createElement(
        DivText,
        _babelHelpers._extends({}, rest, { key: term.text }),
        index.renderHTML(term.text)
      );
    })
  );
};
TermText.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TermText"
};

module.exports = TermText;
//# sourceMappingURL=text.js.map
